import React, { createRef } from "react";
import {
  Form,
  Input,
  InputNumber,
  message,
  Popconfirm,
  Select,
  Table,
  Button,
  Typography,
  Space,
  DatePicker,
  TimePicker,
  Tag,
  Avatar,
  Row,
  Col,
  Dropdown,
  Checkbox,
  Modal,
  Image,
  Tooltip as AntTooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext, StoreProvider } from "../store/RootStore";
import { Link } from "react-router-dom";
import config from "../config";
import {
  DeleteFilled,
  DownloadOutlined,
  EditFilled,
  PlusOutlined,
  UserOutlined,
  DownOutlined,
  ExportOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ReactLeafletGoogleLayer from "react-leaflet-google-layer";
import { MapContainer, TileLayer, Marker, Popup, Tooltip } from "react-leaflet";
import moment from "moment";
import InventoryReportStore from "../store/InventoryReportStore";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import L from "leaflet";
import MapForVehiclePosition from "./MapForVehiclePosition";
import AdditionalContentInMap from "./AdditionalContentInMap";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import Cookies from "js-cookie";
import PythonMessageAlert from "./PythonMessageAlert";
import { decode as base64_decode } from "base-64";

const dotIcon = L.divIcon({
  className: "dot-icon",
  iconSize: [8, 8],
  html: ' <div style="width: 20px; height: 20px; background-color: red; border-radius: 50%;"></div>',
});
const { RangePicker } = DatePicker;
const { Option } = Select;
dayjs.extend(customParseFormat);
const { Search } = Input;
const dateFormat = "DD-MM-YYYY hh:mmA";
const defaultValue = moment().startOf("day").hour(0).minute(0).second(0);

class InventoryReportList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.InventoryReportStore = new InventoryReportStore(this);
    this.pythonMessageRef = createRef();

    this.state = {
      loading: false,
      exportLoading: false,
      pageSize: 50,
      currentPage: 1,
      company_name: "",
      listUpdated: 0,
      companyId: "",
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD 23:59:59"),
      selectedWarehouse: "",
      selectedInventories: [],
      selectAllInventory: false,
      listData: 0,
      modalVisible: false,
      column: "",
      filter: "",
      showMap: false,
      Notcompany: false,
      Notasset: false,
      Notdate: false,
      showMonthPopup: false,

      selectedColumns: [
        {
          // title: "Vehicle No",
          title: context.translate("_FLEET_DASHBORD_RULETRIGGER_VEHICLE_"),
          dataIndex: "vehicleNo",
          key: "vehicleNo",
          width: 15,
          ellipsis: { showTitle: true },
        },
        {
          // title: "Date/Time",
          title: context.translate("_FLEET_REPORTS_DATE_"),
          dataIndex: "timestamp",
          key: "timestamp",
          width: 15,
          ellipsis: { showTitle: true },

           render: (value) => {
            if (!value) return null;

            return dayjs.utc(Number(value)).format("DD-MM-YYYY hh:mm:ss A");
            },
        },
        {
          title: context.translate("_FLEET_DASHBORD_NEWPOI_TYPEDDL_WAREHOUSE_"),
          dataIndex: "warehouse",
          key: "warehouse",
          width: 15,
        },
        {
          title: context.translate("_INVENTORY_"),
          dataIndex: "inventory",
          key: "inventory",
          width: 15,
        },

        {
          // title: "Odometer",
          title: context.translate("_TEMP_"),
          dataIndex: "temp",
          key: "temp",
          ellipsis: { showTitle: true },
          width: 15,
        },
        {
          // title: "Event",
          title: context.translate("_HUMIDITY_"),
          dataIndex: "humidity",
          key: "humidity",
          width: 15,
          ellipsis: { showTitle: true },
        },
        {
          // title: "Event",
          title: context.translate("_UPDATE_DATE_"),
          dataIndex: "updateDate",
          key: "updateDate",
          width: 15,
          ellipsis: { showTitle: true },
            render: (value) => {
            if (!value) return null;

            return dayjs.utc(Number(value)).format("DD-MM-YYYY hh:mm:ss A");
            },
              
        },
        {
          // title: "Event",
          title: context.translate("_RESPONSE_"),
          dataIndex: "waslResponse",
          key: "waslResponse",
          width: 15,
          ellipsis: { showTitle: true },
        },
      ],
    };
    this.ExportMenuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={Excel}
              ></Image>
              {context.translate("_EXPORT_AS_EXCEL_")}
            </div>
          ),
          key: "excel",
        },
        // {
        //   label: (
        //     <div
        //       style={{
        //         display: "flex",
        //         alignItems: "center",
        //         gap: "5px",
        //       }}
        //     >
        //       {" "}
        //       <Image
        //         style={{ height: "18px", width: "18px", borderRadius: "0px" }}
        //         src={CSV}
        //       ></Image>
        //       {context.translate("_EXPORT_AS_CSV_")}
        //     </div>
        //   ),
        //   key: "csv",
        // },
        // {
        //   label: (
        //     <div
        //       style={{
        //         display: "flex",
        //         alignItems: "center",
        //         gap: "5px",
        //       }}
        //     >
        //       {" "}
        //       <Image
        //         style={{ height: "18px", width: "18px", borderRadius: "0px" }}
        //         src={XML}
        //       ></Image>
        //       {context.translate("_EXPORT_AS_XML_")}
        //     </div>
        //   ),
        //   key: "xml",
        // },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={PDF}
              ></Image>
              {context.translate("_EXPORT_AS_PDF_")}
            </div>
          ),
          key: "pdf",
        },
      ],
      onClick: async (val) => {
        let result = [];
        console.log(val);
        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          var getData = {
            companyId: this.state.companyId,
            warehouseId: this.state.selectedWarehouse,
            inventoryId: this.state.selectedInventories,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            colList: result.toString(),
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
          };

          this.setState({ exportLoading: true });
          try {
            if (val.key == "excel") {
              await this.InventoryReportStore.exportExcel(getData);
              const isSuccess =
                this.InventoryReportStore?.pythonReportMessage === true;
              const isError =
                this.InventoryReportStore?.pythonReportErrorMessage;

              if (isSuccess || isError) {
                await this.setState({
                  reportmessage: isSuccess ? "success" : "error",
                });
                await this.triggerReport();
              }
            }
            if (val.key == "pdf") {
              await this.InventoryReportStore.exportpdf(getData);

              const isSuccess =
                this.InventoryReportStore?.pythonReportMessage === true;
              const isError =
                this.InventoryReportStore?.pythonReportErrorMessage;

              if (isSuccess || isError) {
                await this.setState({
                  reportmessage: isSuccess ? "success" : "error",
                });
                await this.triggerReport();
              }
            }
            if (val.key == "csv") {
              this.InventoryReportStore.exportcsv(getData);
            }
            if (val.key == "xml") {
              this.InventoryReportStore.exportxml(getData);
            }
          } finally {
            this.setState({ exportLoading: false });
          }
        }
      },
    };

    this.newColumns = [
      ...this.state.selectedColumns,
       {
          // title: "Event",
          title: context.translate("_TAG_"),
          dataIndex: "tag",
          key: "tag",
          width: 15,
          ellipsis: { showTitle: true },
        },
        {
          // title: "Event",
          title: context.translate("_LAST_TAG_"),
          dataIndex: "lastTag",
          key: "lastTag",
          width: 15,
          ellipsis: { showTitle: true },
        },
        {
          // title: "Event",
          title: context.translate("_INPUT_1_"),
          dataIndex: "input1",
          key: "input1",
          width: 15,
          ellipsis: { showTitle: true },
        },
         {
          // title: "Event",
          title: context.translate("_INPUT_2_"),
          dataIndex: "input2",
          key: "input2",
          width: 15,
          ellipsis: { showTitle: true },
        },
        {
          // title: "Event",
          title: context.translate("_INPUT_3_"),
          dataIndex: "input3",
          key: "input3",
          width: 15,
          ellipsis: { showTitle: true },
        },
        {
          // title: "Event",
          title: context.translate("_INPUT_4_"),
          dataIndex: "input4",
          key: "input4",
          width: 15,
          ellipsis: { showTitle: true },
        },
        {
          // title: "Event",
          title: context.translate("_INPUT_5_"),
          dataIndex: "input5",
          key: "input5",
          width: 15,
          ellipsis: { showTitle: true },
        }
    //   {
    //     // title: "Event Description",
    //     title: context.translate("_EVENT_DESCRIPTION_"),
    //     dataIndex: "EventDescription",
    //     key: "EventDescription",
    //     width: 15,
    //     ellipsis: { showTitle: true },
    //   },
    //   {
    //     // title: "RFID",
    //     title: context.translate("_FLEET_DASHBORD_SETTING_RFID_"),
    //     dataIndex: "RFID",
    //     key: "RFID",
    //     width: 15,
    //     ellipsis: { showTitle: true },
    //   },
    //   {
    //     // title: "RFID1",
    //     title: context.translate("_RFID1_"),
    //     dataIndex: "RFID1",
    //     key: "RFID1",
    //     width: 15,
    //     ellipsis: { showTitle: true },
    //   },
    ];
  }
  refreshList = async () => {
    await this.setState({ loading: false, current: 1, currentPage: 1 });
    await this.showData();
  };
  triggerReport = () => {
    this.pythonMessageRef.current.show(); // show the modal
  };
  async componentDidMount() {
    this.setState({ pageSize: 50 });
    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }

    await this.setState({ column: this.state.selectedColumns });
  }
  async componentDidUpdate(prevProps, prevState) {
    if (this.state.showMap) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      });
    }
  }
  async handleTableChange(pagination, filters, sorter) {
    //   console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    // this.handleSearch();
    await this.showData();
  }

  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.setState({ currentPage: 1, companyId: comp?.value });
    await this.setState({ selectedWarehouse: "", selectedInventories: [], selectAllInventory: false });

    await this.InventoryReportStore.getWarehouseByCompanyId({ companyId: comp?.value });

    await this.setState({ listUpdated: 1 });

    // this.handleSearch();
  }

  addMonths = (date, months) => {
    // date.setMonth(date.getMonth() + months);
    // date = date + months;
    var indx = dayjs().month() + -6;
    // return date.format("YYYY-MM-DD HH:mm:ss");
    return dayjs().month(indx);
  };
  checkFromDate(dates) {
    //  var fromDate = dates.format("YYYY-MM-DD HH:mm:ss");
    var fromDate = dates;
    var pdate = this.addMonths();
    if (pdate > fromDate) {
      //  Ext.Msg.show({
      //      title: fleet.Language.get('_FLEET_ALERT_'),
      //      msg: fleet.Language.get('_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_'),
      //      buttons: Ext.Msg.OK,
      //  });
      this.setState({ showMonthPopup: true });
      return false;
    } else {
      return true;
    }
  }

  async handleSearch() {
    this.setState({ Notasset: false });
    await this.InventoryReportStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
    });

    await this.setState({ listUpdated: 1 }); //need to reload data
  }

  showData = async () => {
    console.log("show data");
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }

    if (!this.state.fromDate) {
      this.setState({ Notdate: true });
    } else {
      this.setState({ Notdate: false });
    }

    if (this.state.companyId && this.state.fromDate && this.state.toDate) {
      console.log("true");
      this.setState({ Notcompany: false });
      if (this.checkFromDate(this.state.fromdateStdTime)) {
        await this.InventoryReportStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          warehouseId: this.state.selectedWarehouse,
          inventoryId: this.state.selectedInventories,
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
        });
        await this.setState({ listData: 1 });
      }
    }
  };
  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState({
        fromdateStdTime: dates[0],
        fromDate: dates[0]?.format(format),
        toDate: dates[1]?.format(format),
      });
    } else {
      this.setState({ fromDate: "", toDate: "" });
    }
  };

  handleCheckboxChange = async (column) => {
    console.log(column);
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );
      console.log(filtered);
      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      console.log("adsf");
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };
  render() {
    //console.log('in render1')
    const companyInputStyle = this.state.Notcompany
      ? { border: "1px solid red", width: "150px", borderRadius: "8px" }
      : { width: "150px" };

    return (
      <>
        {/* <div style={{ padding: 0 }}>
          <Row className="headerFixed" style={{ height: "50px" }}>
            <Col span={12}>
              <div className="heading">
                {this.context.translate("_FLEET_REPORTS_EVENTREPORT_TITLE_")}
              </div>
            </Col>
            <Col
              span={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space
                style={{
                  float:
                    this.context.locale.direction == "ltr" ? "right" : "left",
                }}
              >
             

                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>

                <Dropdown
                  disabled={
                    this.eventReportStore?.eventReport?.length > 0
                      ? false
                      : true
                  }
                  menu={this.menuProps}
                >
                  <Button 
                  className="exportDropdown"
                  // style={{ backgroundColor: config.activeColor }}
                  >
                    <Space>
                      {this.context.translate("_EXPORT_")}
                      <DownOutlined />
                    </Space>
                  
                  </Button>
                </Dropdown>
              </Space>
            </Col>
          </Row>
        </div> */}
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={(value) => this.handleChange(value)}
                  allowClear={true}
                  style={{ width: 150 }}
                  status={this.state.Notcompany ? "error" : false}
                />

                {/* Warehouse Dropdown */}
                <Select
                  className="searchInput"
                  value={this.state.selectedWarehouse ? this.state.selectedWarehouse : null}
                  onChange={async (val) => {
                    await this.setState({
                      selectedWarehouse: val,
                      selectedInventories: [],
                      selectAllInventory: false,
                    });
                    await this.InventoryReportStore.getInventoryByCompanyId({
                      companyId: this.state.companyId,
                      warehouseId: val,
                    });
                    await this.setState({ listUpdated: 1 });
                  }}
                  style={{ width: 150 }}
                  showSearch
                  placeholder={this.context.translate(
                    "_FLEET_DASHBORD_NEWPOI_TYPEDDL_WAREHOUSE_"
                  )}
                  filterOption={(inputValue, option) => {
                    if (option.children) {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(inputValue.toLowerCase()) >= 0
                      );
                    }
                  }}
                >
                  {this.InventoryReportStore?.warehouseArray?.map((val) => {
                    return (
                      <Option key={val.id} value={val.id}>{val.warehouse}</Option>
                    );
                  })}
                </Select>

                {/* Inventory Multi-select with All Checkbox */}
                <Checkbox
                  checked={this.state.selectAllInventory}
                  onChange={async (e) => {
                    const checked = e.target.checked;
                    await this.setState({ selectAllInventory: checked });
                    if (checked) {
                      const allIds = this.InventoryReportStore?.inventoryArray?.map(
                        (val) => val.id
                      );
                      await this.setState({ selectedInventories: allIds });
                    } else {
                      await this.setState({ selectedInventories: [] });
                    }
                  }}
                />
                {this.context.translate("_ALL_")}
                {"  "}
                <Select
                  className="searchInput"
                  mode="multiple"
                  value={this.state.selectedInventories}
                  onChange={(val) => {
                    this.setState({ selectedInventories: val });
                    if (
                      this.InventoryReportStore?.inventoryArray?.length > val.length
                    ) {
                      this.setState({ selectAllInventory: false });
                    } else {
                      this.setState({ selectAllInventory: true });
                    }
                  }}
                  maxTagCount="responsive"
                  fieldNames={{ label: "inventory", value: "id" }}
                  placeholder={this.context.translate("_INVENTORY_")}
                  optionFilterProp="children"
                  options={this.InventoryReportStore?.inventoryArray}
                  style={{ width: 160 }}
                />

                <RangePicker
                  placeholder={[
                    this.context.translate("_FROM_DATE_TIME_"),
                    this.context.translate("_TO_DATETIME_"),
                  ]}
                  format="DD-MM-YYYY hh:mmA"
                  style={{ width: 400, borderRadius: "25px" }}
                  onChange={(val) => {
                    this.onDateTimeChange(val);
                  }}
                  // disabledDate={(current) => {
                  //   return current && current > dayjs();
                  // }}
                  showTime={{
                    format: "h:mmA",
                    defaultValue: [
                      dayjs().startOf("day"),
                      dayjs().endOf("day"),
                    ],
                  }}
                  status={this.state.Notdate ? "error" : false}
                  defaultValue={[dayjs().startOf("day"), dayjs().endOf("day")]}
                />{" "}
                <Button
                  type="primary"
                  onClick={() => {
                    this.showData();
                    this.setState({ currentPage: 1 });
                  }}
                >
                  {" "}
                  {/* Show */}
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>
                <Button onClick={() => this.setState({ modalVisible: true })}>
                  {this.context.translate("_COLUMNS_")}
                </Button>
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={4}
            >
              <Space>
                <AntTooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </AntTooltip>
                <Button
                  className={`downloadExcelButton ${
                    this.state.exportLoading ? "downloadExcelButtonLoading" : ""
                  }`}
                  loading={this.state.exportLoading}
                  disabled={
                    this.InventoryReportStore?.InventoryReport?.length > 0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.ExportMenuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>

          <Modal
            open={this.state.modalVisible}
            width={300}
            // title="Select Columns"
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {console.log(this.newColumns, "Df")}
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.InventoryReportStore?.total}
            columns={this.state.column}
            dataSource={this.InventoryReportStore?.InventoryReport}
            // pagination={{
            //   pageSize: this.state.pageSize,
            //   //  current:this.state.pageNo
            //   total:this.eventReportStore?.total || 0

            // }}
            loading={this.InventoryReportStore?.loading}
            onChange={this.handleTableChange}
            // scroll={{
            //   // y: this.state.clientHeight-240,
            //   x: 100,
            // }}
          />
          {/* {this.state.vehicleObj && (
          <MapForVehiclePosition
            vehicleObj={this.state.vehicleObj}
            heading={this.state.heading}
            closeMapModal={(resp) => {
              this.setState({ vehicleObj: resp });
            }}
          />
          
        )} */}
          {this.state.showMap && (
            <Modal
              className="multiTracking-popup"
              title={
                <div>
                  {this.context.translate("_FLEET_EVENT_REPORT_")}
                  <CloseOutlined
                    onClick={() => this.setState({ showMap: false })}
                  />
                </div>
              }
              centered
              maskClosable={false}
              bodyStyle={{
                height: "60vh",
                //width: "900px",
              }} // Adjust the dimensions as needed
              width={1000}
              open={this.state.showMap}
              onCancel={() => this.setState({ closeModal: true })}
              closable={false}
              footer={null}
            >
              {/* <Modal
           title=<div>
          {this.context.translate("_FLEET_RULETRIGGER_REPORT_")}
           <CloseOutlined onClick={() => this.setState({ showMap: false })} />
         </div>
            // title="Event View on Map"
            open={this.state.showMap}
            centered
            // bodyStyle={{ height: 1000 }}
            width={850}
            height={400}
            onOk={() => this.setState({ showMap: false })}
            onCancel={() => this.setState({ showMap: false })}
            footer={false}
          > */}
              <div
                dir={this.context.locale.language === "arabic" ? "ltr" : "ltr"}
                className={
                  this.context.locale.language === "arabic"
                    ? "arabic-map-container"
                    : ""
                }
              >
                <MapContainer
                  ref={this.mapRef}
                  zoom={30}
                  center={[
                    this.state.modalInfoObj?.latitude,
                    this.state.modalInfoObj?.longitude,
                  ]}
                  style={{
                    position: "relative",
                    height: "60vh",

                    // borderRadius: "0px 0px 5px 5px",
                  }}
                  bounds={
                    this.state.modalInfoObj
                      ? [
                          [
                            this.state.modalInfoObj.latitude,
                            this.state.modalInfoObj.longitude,
                          ],
                          [
                            this.state.modalInfoObj.latitude,
                            this.state.modalInfoObj.longitude,
                          ],
                        ]
                      : []
                  }
                >
                  <ReactLeafletGoogleLayer />

                  <Marker
                    icon={L.icon({
                      iconUrl: require("../assets/images/map-car-icon-green.png"),
                      iconSize: [25, 40], // size of the icon
                    })}
                    position={[
                      this.state.modalInfoObj?.latitude,
                      this.state.modalInfoObj?.longitude,
                    ]}
                    eventHandlers={{
                      mouseover: (event) => event.target.openPopup(),
                      mouseout: (event) => event.target.closePopup(),
                    }}
                  >
                    <Tooltip permanent={true} direction="top">
                      <div
                        style={{
                          backgroundColor: "#00ff00",
                          border: "solid 1px #000",
                          textAlign: "center",
                          padding: 0,
                        }}
                      >
                        <b>Vehicle No : {this.state.modalInfoObj?.vehicleNo}</b>
                        <br />
                        <b>Speed : {this.state.modalInfoObj?.speed}Kmh</b>
                      </div>
                    </Tooltip>
                    <Popup direction="top">
                      <b>Event : {this.state.modalInfoObj?.eventType}</b>
                      <br />
                      <b>
                        Location : {this.state.modalInfoObj?.formatted_address}
                      </b>
                      <br />
                      <b>Speed : {this.state.modalInfoObj?.speed}Kmh</b>
                    </Popup>
                  </Marker>
                  <AdditionalContentInMap This={this} size="small" />
                </MapContainer>
              </div>
            </Modal>
          )}
          <Modal
            width={350}
            className="alert-model"
            title={
              <div>
                {" "}
                <i
                  style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                  class="bi bi-exclamation-triangle"
                ></i>{" "}
                {this.context.translate("_FLEET_ALERT_")}
              </div>
            }
            open={this.state.showMonthPopup}
            onOk={() => this.setState({ showMonthPopup: false })}
            onCancel={() => this.setState({ showMonthPopup: false })}
            footer={false}
          >
            {/* For reports prior to 6 months please contact administrator */}
            {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
          </Modal>
           {
            <div>
              <PythonMessageAlert
                ref={this.pythonMessageRef}
                message={this.state.reportmessage}
              />
            </div>
          }
        </div>
      </>
    );
  }
}
InventoryReportList.contextType = StoreContext;
export default observer(withRouter(InventoryReportList));
